const CASINO_PREFIX = 'casino.';
const SERVICE_PREFIX = 'live-casino.';

const SERVICE_FEATURE_PREFIX = `${CASINO_PREFIX}${SERVICE_PREFIX}`;

export const FEATURES = {
  TOP_SLIDER: `${SERVICE_FEATURE_PREFIX}top_slider`,
  SHOW_MAINTENANCE_PAGE: `${SERVICE_FEATURE_PREFIX}show_maintenance_page`,
  ENABLED_CROSS_SALES: `${SERVICE_FEATURE_PREFIX}enabled_cross_sales`,
  ENABLED_MOBILE_IFRAME_GAME_RUN: `${SERVICE_FEATURE_PREFIX}enabled_mobile_iframe_game_run`,
  ENABLED_FORCE_MOBILE_IFRAME_GAME_RUN: `${SERVICE_FEATURE_PREFIX}enabled_force_mobile_iframe_game_run`,
  ENABLED_ONE_CLICK_DEPOSIT: `${SERVICE_FEATURE_PREFIX}enable_one_click_deposit`,
  USE_NEW_SEARCH_API: `${SERVICE_FEATURE_PREFIX}use_new_search_api`,
  USE_THREE_COLUMNS_FOR_GAMES: `${SERVICE_FEATURE_PREFIX}use_three_columns_for_games`,
  ENABLE_HALL_OF_FAME: `${SERVICE_FEATURE_PREFIX}enable_hall_of_fame`,
  ENABLE_DEPOSIT_WIDGET: `${SERVICE_FEATURE_PREFIX}enable_deposit_widget`,
  ENABLE_COMMON_CONFIG_ORDERING: `${SERVICE_FEATURE_PREFIX}common-config-ordering`,
  ENABLE_BIG_WINS_FEED: `${SERVICE_FEATURE_PREFIX}enable_big_wins_feed`,
  ENABLE_ADAPTIVE_IFRAME: `${SERVICE_FEATURE_PREFIX}enable_adaptive_game_desktop_launch`,
  ENABLED_GAME_OF_THE_DAY_WIDGET: `${SERVICE_FEATURE_PREFIX}enable_game_of_the_day_widget`,
  ENABLED_FAVORITE_GAMES: `${SERVICE_FEATURE_PREFIX}enabled_favorite_games`,
  ENABLE_GAME_PAGE_RECOMMENDATIONS: `${SERVICE_FEATURE_PREFIX}enable_game_page_recommendations`,
  ENABLE_INSUFFICIENT_FUNDS: `${SERVICE_FEATURE_PREFIX}enable_insufficient_funds`,
  ENABLED_RANDOM_SLOT_WIDGET: 'casino.live-casino.enabled_random_slot_widget',
  CAN_USE_DEPOSIT_BONUS: `${SERVICE_FEATURE_PREFIX}can_use_deposit_bonus`,
  USE_INCOGNITO_BRAND: `${SERVICE_FEATURE_PREFIX}use_incognito_brand`,
  USE_MOCK_DATA_MODE: `${SERVICE_FEATURE_PREFIX}use_mock_data_mode`,
  USE_MULTI_CURRENCY: `${SERVICE_FEATURE_PREFIX}use_multi_currency`,
  ENABLED_SLIDER_ANIMATION: `${SERVICE_FEATURE_PREFIX}enabled_slider_animation`,
  HOW_TO_PLAY: `${SERVICE_FEATURE_PREFIX}how_to_play`,
  ENABLE_LOCALIZATION_FALLBACK: `${CASINO_PREFIX}enable_localization_fallback`,
  USE_LOSS_LIMITS: `${CASINO_PREFIX}use_loss_limits`,
  SHOW_RECENTS_MIGRATION_MODAL: `${CASINO_PREFIX}show_recents_migration_modal`,
  AMS_ORDERING: `${SERVICE_FEATURE_PREFIX}enable_ams_ordering`,
  ENABLE_SLIDER_NAVIGATION_WIDGET: `${SERVICE_FEATURE_PREFIX}enable_slider_navigation_widget`,
  ENABLE_ANIMATED_TIPS_SLIDER_NAVIGATION_WIDGET: `${SERVICE_FEATURE_PREFIX}enable_animated_tips_slider_navigation_widget`,
  ANIMATED_TIPS_PARAMS_SLIDER_NAVIGATION_WIDGET: `${SERVICE_FEATURE_PREFIX}animated_tips_params_slider_navigation_widget`,
  ENABLED_SITEWIDE_SLIDER_NAVIGATION_WIDGET: `${SERVICE_FEATURE_PREFIX}enabled_sitewide_slider_navigation_widget`,
  THEME_SETTINGS: `${SERVICE_FEATURE_PREFIX}theme_settings`,
  EXTERNAL_NAVBAR: `${CASINO_PREFIX}external_navbar`,
  CROSS_DOMAIN_CLICKSTREAM_ID: `${CASINO_PREFIX}enable_cross_domain_clickstream_id`,
  ENABLED_PROMO_WIDGET: `${SERVICE_FEATURE_PREFIX}enabled_promo_widget`,
  SENTRY: `${CASINO_PREFIX}sentry`,
  USE_PROMO_BONUS_SYSTEM: `${CASINO_PREFIX}enabled_unified_promo_bonus_system`,
  ENABLE_LATESTS_ABA_REQUESTS: `${CASINO_PREFIX}enabled_latest_aba_requests`,
  RECENT_GAMES_ON_BE: `${CASINO_PREFIX}recent_games_on_be`,
  ENABLED_STICKY_SIDE_MENU: `${CASINO_PREFIX}enabled_sticky_side_menu`,
  DISABLE_UNMOUNT_MODE: `${CASINO_PREFIX}disable_unmount_mode_switcher`,
  TOURNAMENT_DEEPLINK: `${CASINO_PREFIX}tournament_deeplink`,
  ENABLE_DEMO_MODE: `${CASINO_PREFIX}enable_demo_mode`,
  PROVIDERS_SORTING: `${SERVICE_FEATURE_PREFIX}providers_sorting`,
  ABSENT_IMAGE_LOG: `${CASINO_PREFIX}absent-image-log`,
};

export const DEFAULT_VALUES = {
  AMS_ORDERING: false,
  TOP_SLIDER: false,
  SHOW_MAINTENANCE_PAGE: false,
  ENABLED_MOBILE_IFRAME_GAME_RUN: false,
  ENABLED_FORCE_MOBILE_IFRAME_GAME_RUN: false,
  ENABLED_ONE_CLICK_DEPOSIT: false,
  USE_NEW_SEARCH_API: false,
  ENABLE_HALL_OF_FAME: false,
  ENABLE_DEPOSIT_WIDGET: false,
  ENABLE_COMMON_CONFIG_ORDERING: false,
  ENABLE_BIG_WINS_FEED: false,
  ENABLE_ADAPTIVE_IFRAME: false,
  ENABLE_GAME_PAGE_RECOMMENDATIONS: false,
  ENABLE_INSUFFICIENT_FUNDS: false,
  CAN_USE_DEPOSIT_BONUS: false,
  USE_INCOGNITO_BRAND: false,
  USE_MOCK_DATA_MODE: false,
  USE_MULTI_CURRENCY: false,
  ENABLE_LOCALIZATION_FALLBACK: true,
  SHOW_RECENTS_MIGRATION_MODAL: false,
  HOW_TO_PLAY: true,
  USE_LOSS_LIMITS: false,
  THEME_SETTINGS: {},
  CROSS_DOMAIN_CLICKSTREAM_ID: false,
  EXTERNAL_NAVBAR: false,
  SENTRY: true,
  ENABLE_ANIMATED_TIPS_SLIDER_NAVIGATION_WIDGET: false,
  ANIMATED_TIPS_PARAMS_SLIDER_NAVIGATION_WIDGET: {},
  USE_PROMO_BONUS_SYSTEM: false,
  RECENT_GAMES_ON_BE: false,
  ENABLED_STICKY_SIDE_MENU: false,
  DISABLE_UNMOUNT_MODE: false,
  TOURNAMENT_DEEPLINK: '',
  ENABLE_DEMO_MODE: true,
  PROVIDERS_SORTING: false,
  ABSENT_IMAGE_LOG: false,
};

export const INITIAL_FEATURE_FLAGS = Object.keys(FEATURES).reduce(
  (features, featureName) => {
    features[FEATURES[featureName]] = {
      defaultValue: DEFAULT_VALUES[featureName],
    };
    return features;
  },
  {}
);

export default FEATURES;
